export interface PendingChangePosition {
  positionId: number;
}

export interface PendingChangeAddModifyPosition extends PendingChangePosition {
  type: 'modifyPosition';
  properties?: string[];
}

export interface PendingChangeMovePosition extends PendingChangePosition {
  type: 'movePosition';
}
export interface PendingChangeNone {
  type: 'none';
}

export interface PendingChangeAddPosition {
  type: 'addPosition';
}

export interface PendingChangeModify {
  type: 'modify';
}

export interface PendingChangeRemovePosition {
  type: 'removePosition';
}

export type PendingChange =
  | (
      | PendingChangeModify
      | PendingChangeNone
      | PendingChangeAddModifyPosition
      | PendingChangeMovePosition
      | PendingChangeAddPosition
      | PendingChangeRemovePosition
    ) & {
      pending: boolean;
    };

export const PENDING_NONE: PendingChange = {
  pending: false,
  type: 'none',
};
